const priority = {
  'news-priority-form-date-label': 'Date',
  'news-priority-filter-title': 'Select news by date',
  'news-priority-title': 'Set correct order for news',
  'news-priority-empty': 'There is no any news for this date.',
};

export default priority;
